// extracted by mini-css-extract-plugin
module.exports = {"back":"back_back__1Rnom"};